import { render, staticRenderFns } from "./backWall.vue?vue&type=template&id=0709cfc4&scoped=true&"
import script from "./backWall.vue?vue&type=script&lang=js&"
export * from "./backWall.vue?vue&type=script&lang=js&"
import style0 from "./backWall.vue?vue&type=style&index=0&id=0709cfc4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0709cfc4",
  null
  
)

component.options.__file = "backWall.vue"
export default component.exports